import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, MapPin } from 'lucide-react';
import { useLanguage } from './LanguageContext';
import { translations } from '../translations';

export function Footer() {
  const { language } = useLanguage();
  const t = translations.footer;

  return (
    <footer className="bg-gray-900 text-gray-400 py-12">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Logo and Company Info */}
          <div>
            <Link to="/" className="flex items-center space-x-2 mb-4">
              <Shield className="w-6 h-6 text-blue-500" />
              <span className="text-xl font-bold text-white">secusoc.io</span>
            </Link>
            <div className="flex items-start space-x-2 mt-4">
              <MapPin className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
              <div>
                <p className="text-gray-300">53, Avenue Blanc</p>
                <p className="text-gray-300">1202 Geneva</p>
                <div className="flex items-center space-x-2 mt-1">
                  <span className="text-gray-300">Switzerland</span>
                  {/* Enhanced Swiss Flag */}
                  <div className="relative w-6 h-6 bg-red-600 rounded-sm shadow-lg transform hover:scale-110 transition-transform duration-300">
                    {/* White Cross - Horizontal */}
                    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-4 h-1 bg-white rounded-sm"></div>
                    {/* White Cross - Vertical */}
                    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-1 h-4 bg-white rounded-sm"></div>
                    {/* Subtle Gradient Overlay */}
                    <div className="absolute inset-0 bg-gradient-to-br from-white/10 to-transparent rounded-sm"></div>
                    {/* Inner Shadow */}
                    <div className="absolute inset-0 shadow-inner rounded-sm"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Navigation Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">
              {language === 'fr' ? 'Navigation' : 'Navigation'}
            </h3>
            <div className="space-y-2">
              <Link to="/monitoring" className="block hover:text-white transition-colors duration-300">
                {t.monitoring[language]}
              </Link>
              <Link to="/incident-response" className="block hover:text-white transition-colors duration-300">
                {t.incidentResponse[language]}
              </Link>
              <Link to="/threat-hunting" className="block hover:text-white transition-colors duration-300">
                {t.threatHunting[language]}
              </Link>
              <Link to="/siem" className="block hover:text-white transition-colors duration-300">
                SIEM
              </Link>
            </div>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">
              {language === 'fr' ? 'Légal' : 'Legal'}
            </h3>
            <div className="space-y-2">
              <Link to="/privacy" className="block hover:text-white transition-colors duration-300">
                {t.privacy[language]}
              </Link>
              <Link to="/terms" className="block hover:text-white transition-colors duration-300">
                {t.terms[language]}
              </Link>
              <Link to="/contact" className="block hover:text-white transition-colors duration-300">
                {t.contact[language]}
              </Link>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 mt-8 text-center">
          <p>&copy; 2025 secusoc.io. {t.rights[language]}.</p>
        </div>
      </div>
    </footer>
  );
}